import {API_ENDPOINT, API_METHOD_PREFIX} from 'config/config';
import {getApi} from 'modules/api';

import {INIT_INDEX} from 'util/constants';

import endpoints from 'config/endpoints';

const CLEAN_ERRORS = 'CLEAN_ERRORS';
const LOGIN_REQUEST = 'LOGIN_REQUEST';
const INIT_RESET_PASSWORD = 'INIT_RESET_PASSWORD';
const RESET_REQUEST = 'RESET_REQUEST';
const RESET_SUCCESS = 'RESET_SUCCESS';
const RESET_ERROR = 'RESET_ERROR';
const CHANGE_REQUEST = 'CHANGE_REQUEST';
const LOGIN_RECOVER_REQUEST = 'LOGIN_RECOVER_REQUEST';
const LOGIN_RECOVER_SUCCESS = 'LOGIN_RECOVER_SUCCESS';
const LOGIN_RECOVER_ERROR = 'LOGIN_RECOVER_ERROR';

export const CHANGE_SUCCESS = 'CHANGE_SUCCESS';
export const CHANGE_ERROR = 'CHANGE_ERROR';

export const loginRequest = () => ({type: LOGIN_REQUEST});

const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
const WHOAMI_SUCCESS = 'WHOAMI_SUCCESS';

export const loginRecover = (password, passwordConfirm, recoverKey, uid) => dispatch => {
    dispatch({type: LOGIN_RECOVER_REQUEST});

    return getApi().post(`${API_METHOD_PREFIX}v2/auth/password/reset/confirm/`, {new_password1: password, new_password2: passwordConfirm, token: recoverKey, uid}, true)
        .then(json => {
            dispatch({type: LOGIN_RECOVER_SUCCESS, json});
        })
        .catch(error => {
            dispatch({type: LOGIN_RECOVER_ERROR, error});
        });
};

export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const logout = () => dispatch => {
    getApi().destroyAccessToken();
    window.localStorage.clear();
    window.sessionStorage.clear();
    dispatch({type: LOGOUT_SUCCESS});

};

export const loginReceive = remember => dispatch => {
    dispatch({type: LOGIN_SUCCESS, remember});

    getApi().get(endpoints.whoami.endpoint)
        .then(json => {
            dispatch({type: WHOAMI_SUCCESS, user: json.results[INIT_INDEX]});
        })
        .catch(err => {
            console.error(err);
            dispatch(logout());
        });
};

const LOGIN_ERROR = 'LOGIN_ERROR';

export const loginError = error => ({
    type: LOGIN_ERROR,
    error
});

export const cleanErrors = () => dispatch => {
    dispatch({type: CLEAN_ERRORS});
};

export const changePassword = ({old, new1, new2}) => dispatch => {
    dispatch({type: CHANGE_REQUEST});

    return getApi().post(`${API_METHOD_PREFIX}v2/auth/password/change/`, {
        old_password:  old,
        new_password1: new1,
        new_password2: new2
    });
};

export const login = (user, pass, remember) => dispatch => {
    dispatch(loginRequest());
    checkPasswordExpiration(user)
        .then(isExpired => {
            if (isExpired) {
                throw new Error('Password expired. Please reset it at https://app.cloudglass.es/#/reset-password');
            }

            return getApi().requestAccessToken(user, pass);
        })
        .then(json => {
            dispatch(loginReceive(remember));
        })
        .catch(error => {
            dispatch(loginError(error));
        });
};

const checkPasswordExpiration = user => {
    const url = `${API_ENDPOINT}/${API_METHOD_PREFIX}${endpoints.checkPasswordExpiration.endpoint}?email=${user}`;

    return fetch(url)
        .then(response => {
            if (response.status === 403) {
                return true; // Password expired
            }

            return false; // Password not expired
        });
};

export const loginCustomerSso = (code, remember) => dispatch => {
    dispatch(loginRequest());

    return getApi().requestCustomerAccessToken(code)
        .then(json => dispatch(loginReceive(remember)))
        .catch(error => {
            dispatch(loginError(error));
            window.location.href = `${window.location.protocol}//${window.location.host}`;
        });
};

export const loginKeycloackSso = (code, remember) => dispatch => {
    dispatch(loginRequest());

    return getApi().requestKeycloackAccessToken(code)
        .then(json => dispatch(loginReceive(remember)))
        .catch(error => {
            dispatch(loginError(error));
            window.location.href = `${window.location.protocol}//${window.location.host}`;
        });
};

export const resetRequest = email => dispatch => {
    dispatch({type: RESET_REQUEST});

    return getApi().post(`${API_METHOD_PREFIX}v2/auth/password/reset/`, {email}, true)
        .then(() => dispatch({type: RESET_SUCCESS}))
        .catch(error => {
            dispatch({type: RESET_ERROR, error});

            throw error;
        });
};

export const initResetPassword = () => ({type: INIT_RESET_PASSWORD});

const LOGIN_RESET = 'LOGIN_RESET';

export const loginVerify = () => (dispatch, getState) => {

    const lastRemember = getState().auth.remember;

    if (getApi().isTokenValid()) {
        dispatch(loginReceive(lastRemember));
    } else if (getApi().grant.refreshToken) {
        dispatch(loginRequest());
        getApi().refreshAccessToken()
            .then(json => dispatch(loginReceive(lastRemember)))
            .catch(error => dispatch(loginError(error)));
    } else {
        dispatch({type: LOGIN_RESET});
    }
};

// Reducers
export const reducer = (state = {
    isLoggedIn:     false,
    isFetching:     false,
    isResetting:    false,
    isChanging:     false,
    remember:       false,
    recoverSuccess: false,
    error:          null,
    user:           null
}, action = {}) => {
    switch (action.type) {
    case CLEAN_ERRORS:
        return {
            ...state,
            resetError:   false,
            recoverError: false,
            loginError:   false
        };
    case LOGIN_RECOVER_SUCCESS:
        return {
            ...state,
            error:          false,
            recoverSuccess: true
        };
    case LOGIN_RECOVER_ERROR:
        return {
            ...state,
            isResetting:    false,
            recoverError:   action.error,
            recoverSuccess: false
        };
    case LOGIN_RECOVER_REQUEST:
        return {
            ...state,
            isResetting:    true,
            error:          false,
            recoverSuccess: false
        };
    case LOGIN_REQUEST:
        return {
            ...state,
            isFetching: true,
            error:      null
        };
    case LOGIN_SUCCESS:
        return {
            ...state,
            isLoggedIn: true,
            remember:   action.remember
        };
    case LOGIN_ERROR:
        return {
            ...state,
            isLoggedIn: false,
            isFetching: false,
            loginError: action.error.message
        };
    case LOGIN_RESET:
        return {
            ...state,
            isLoggedIn: false,
            isFetching: false,
            error:      null,
            user:       null
        };
    case LOGOUT_SUCCESS:
        return {
            ...state,
            isLoggedIn: false,
            user:       null,
            error:      null
        };
    case RESET_ERROR:
        return {
            ...state,
            isResetting: false,
            resetError:  action.error.message
        };
    case INIT_RESET_PASSWORD:
    case RESET_SUCCESS:

        return {
            ...state,
            isResetting: false
        };
    case RESET_REQUEST:

        return {
            ...state,
            error:       '',
            isResetting: true
        };
    case CHANGE_REQUEST:
        return {
            ...state,
            error:      '',
            isChanging: true
        };
    case CHANGE_SUCCESS:
        return {
            ...state,
            isChanging: false
        };
    case CHANGE_ERROR:
        return {
            ...state,
            error:      action.error,
            isChanging: false
        };
    case WHOAMI_SUCCESS:
        return {
            ...state,
            isFetching: false,
            user:       {
                name:           action.user.username,
                isSuperuser:    action.user.is_superuser,
                isStaff:        action.user.is_staff,
                isConsultant:   action.user.is_consultant,
                isActive:       action.user.is_active,
                canImpersonate: action.user.can_impersonate,
                firstName:      action.user.first_name || action.user.username,
                lastName:       action.user.last_name,
                username:       action.user.username,
                email:          action.user.email,
                lastLogin:      action.user.last_login,
                id:             action.user.id,
                services:       action.user.services ? action.user.services : [],
                tenant:         action.user.tenant || [],
                tgc4:           action.user.tgc4 || []
            }
        };
    default:
        return state;
    }
};


/* Redirects to /login if we're not logged in */
export const requireLoggedIn = (store, nextState, replace) => {

    const {auth:{isLoggedIn}} = store.getState();

    if (!isLoggedIn) {
        replace({
            pathname: '/login',
            state:    {nextPathname: nextState.location.pathname}
        });
    }
};

/* Redirects to / if we're logged in */
export const requireAnon = (store, nextState, replace) => {

    const
        state = store.getState(),
        {isLoggedIn} = state.auth;

    if (isLoggedIn) {
        replace('/');
    }
};



// WEBPACK FOOTER //
// ./src/modules/auth.js